import { ApplicabilityType } from '../admin/admin.model';
import { User } from '../shared/shared.model';

export interface Sid {
    id?: number;
    sidId?: string;
    title?: string;
    applicabilityId?: number;
    applicability?: ApplicabilityType;
    deviatedRule?: string;
    impact?: string;
    description?: string;
    rootCause?: string;
    dueDate?: Date;
    ownerGroupId?: number;
    ownerGroup?: string;
    status?: string;
    deviationOwners?: Array<SidDeviationOwner>;
    smeApprovers?: Array<SidSmeApprover>;
    capaActivityStatus?: string;
    capaCount?: number;
    createdBy?: string;
    createdOn?: Date;
    suppName?: string;
    suppTypeOfService?: string;
    suppNoApprovedPo?: boolean;
    suppNotCompliance?: boolean;
    suppNonStandard?: boolean;
    suppOthers?: string;
    canSubmit?: boolean;
    lineMgrCanApprove?:boolean;
    deptHeadCanApprove?:boolean;
    smeCanTag?:boolean;
    smeCanApprove?:boolean;
    
    canUpdate?: boolean;
    submiters?: Array<SidSubmiter>;     
    submiter? : string;  
    smeApprover?: string;

    history? : string;
    UpdatedOn?: Date;
}

export interface OwnerGroup {
    id?: number;
    auditOwnerGroup?: string;
}

export interface SidDeviationOwner {
    deviationOwnerId?: number;
    deviationOwner?: User;
}
export interface SidSmeApprover {
    smeApproverId?: number;
    smeApprover?: User;
}
export interface SidSubmiter {
    sidSubmiterId?: number;
    sidSubmiter?: User;
}

export enum SidStatus {
    DRAFT = 'draft',
    READY_TO_SUBMIT = 'Ready To Submit',
    WAIT_FOR_1ST_APPROVAL = 'Wait For 1st Approval',
    WAIT_FOR_2ND_APPROVAL = 'Wait For 2nd Approval',
    EVIDENCE_SUBMISSION = 'Evidence Submission',
    EVIDENCE_APPROVAL = 'Evidence Approval',
    COMPLETED = 'Completed',
}
